module.exports = __webpack_public_path__ + "media/images/lightbox/close@2x-a6ef151046561fda407525d5ce243d48.png";